<template>
  <footer class="app-footer">
    <v-container>
      <v-row>
        <v-col cols="12" sm="12">
          <address class="address">
            <b>Agência Reguladora do Estado do Ceará</b>
            <br />AV. General Afonso Albuquerque Lima, S/N - Cambeba
            Fortaleza, Ce - Cep: 60.822-325
            <br />Horário de Atendimento: 08:00 às 17:00 HORAS
            <br />
            © 2020-{{new Date().getFullYear()}} - Governo do Estado do Ceará. Todos os direitos reservados.
          </address>
          <ul class="app-footer-socials">
            <li class="app-footer-socials__item">
              <a
                href="https://pt-br.facebook.com/arcefanpage"
                class="app-footer-socials__link"
                target="_blank"
                title="Acessar: Facebook da ARCE"
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </li>
            <li class="app-footer-socials__item">
              <a
                href="https://www.instagram.com/arce_ceara/"
                class="app-footer-socials__link"
                target="_blank"
                title="Acessar: Instagram da ARCE"
              >
                <i class="fab fa-instagram"></i>
              </a>
            </li>
            <li class="app-footer-socials__item">
              <a
                href="https://twitter.com/arceceara"
                class="app-footer-socials__link"
                target="_blank"
                title="Acessar: Twitter da ARCE"
              >
                <i class="fab fa-twitter"></i>
              </a>
            </li>
            <li class="app-footer-socials__item">
              <a
                href="https://www.youtube.com/user/ArceInstitucional"
                class="app-footer-socials__link"
                target="_blank"
                title="Acessar: Youtube da ARCE"
              >
                <i class="fab fa-youtube"></i>
              </a>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: "app-footer"
};
</script>

<style lang="scss" scoped>
.app-footer {
  //background-color: #fff;
  //box-shadow: 0 0 3px #ddd;
  //border-bottom: 10px solid #1c8441;
  margin-top: 50px;
  padding: 30px 0px 0px 0px;
  width: 100%;
  bottom: 0px;
  .title {
    margin: 0px;
    font-weight: 400 !important;
    font-size: 1rem !important;
    text-transform: uppercase;
  }
  .address,
  .hour {
    font-style: normal;
    font-size: 0.9rem;
  }
  .address {
    text-align: center;
    b {
      font-size: 16px !important;
    }
  }
  &-socials {
    padding: 0px;
    list-style: none;
    margin: 20px auto 0px auto;
    text-align: center;
    &__item {
      display: inline-block;
      margin: 0px 10px;
    }
    &__link {
      width: 30px;
      height: 30px;
      background-color: #2e70b6;
      color: #fff;
      display: table;
      border-radius: 50px;
      text-align: center;
      display: flex;
      align-items: center;
      i {
        margin: auto;
      }
    }
  }
}
</style>
